import { Component, ViewChild, Input, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastController, Platform, AlertController, LoadingController, NavController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';
import * as moment from 'moment';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
declare let firebase: any;
declare var jQuery: any;
declare var $: any;
//declare let jQuery: any;
@Component({
  selector: 'footer',
  templateUrl: './footer.html',
  styleUrls: ['footer.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
  @ViewChild('cd', {}) counter;
  @Input() page = '';
  countdownconfig;
  attendance: any;
  showattendance = false;
  showlanguage = false;
  loading: any;
  expired = false;

  constructor(public db: PouchService, private router: Router, private activatedRoute: ActivatedRoute, public loadingCtrl: LoadingController, public http: HttpClient, public navCtrl: NavController, public toastController: ToastController) {
    this.expired = new Date(this.db.gsetting.enddate).getTime() < new Date().getTime();
    setTimeout(() => {
      let plan = this.db.getPlan();

      if (!this.expired && this.db.online && !this.db.connected && plan != 'free' && plan != 'Offline') {
        this.db.login();
      }
    }, 2000);
    if (this.db.appinfo.schema_array.includes('attendance')) {
      this.db.get(this.db.user.id + '_' + new Date().toLocaleDateString().replace(/\//g, ''), 'attendance').then((attendance) => {
        if (attendance != undefined) {
          // check for today attendance
          this.attendance = attendance;
        } else {
          // check for yesterday attendance if not signed out
          let yesterday = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24);

          this.db.get(this.db.user.id + '_' + new Date(yesterday).toLocaleDateString().replace(/\//g, ''), 'attendance').then((attendance) => {
            if (attendance != undefined && attendance.end == null) {
              attendance.yesterday = true;
              this.attendance = attendance;
            } else {
              //no unsignedout attendance
            }
          });
        }
      });
    }
    if (this.db.tawk != undefined && Object.keys(this.db.tawk).length != 0) {
      if (new Date() > new Date(this.db.gsetting.expiredate) || this.db.gsetting.plans[this.db.gsetting.plans.length - 1] == 'free' || this.db.demo || location.hostname == 'localhost') {
        this.db.tawk.showWidget();
        if (!this.db.demo) {
          // dont personalize chat for demo users, they are various visitors
          let request = {
            type: 'tawk_to_hash',
            email: this.db.gsetting.email,
          };
          this.http.post('https://sarutech.com/api/app/rest', JSON.stringify(request)).subscribe((res) => {
            let result: any = res;
            if (result != null) {
              this.db.tawk.setAttributes(
                {
                  license: db.getPlan(),
                  usertype: this.db.user.usertype,
                  username: this.db.user.fullname,
                  version: this.db.appinfo.version,
                  phone: this.db.gsetting.phone,
                  product: this.db.appinfo.product,
                  startdate: this.db.gsetting.startdate,
                  expiredate: this.db.gsetting.expiredate,
                  country: this.db.gsetting.country,
                  name: this.db.gsetting.username,
                  email: this.db.gsetting.email,
                  hash: result.msg,
                },
                function (error) {}
              );
            } else {
              console.log('Cannot get hash value from server');
            }
          });
        }
        jQuery('iframe[title="chat widget"]').each(function (e) {
          $(this).css('margin', '0 0 25px 0');
        });
      } else {
        this.db.tawk.hideWidget();
      }
    }

    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd && !this.db.appinfo.filtered) {
        this.db.previous_route = localStorage.getItem('previous_route');
        await setTimeout(async () => {
          if (this.inAdditionalPages(this.db.previous_route) && this.db.previous_route != null && !this.db.loaded_previous_route && event.url == '/' + this.db.user.homepage) {
            this.db.loaded_previous_route = true; // should no longer be able to load previous route
            let previous_route = this.db.previous_route;
            this.db.previous_route = null;
            this.router.navigateByUrl(previous_route);
          } else if (this.db.previous_route != '/' + this.db.user.homepage && event.url != '/' + this.db.user.homepage && event.url != '/') {
            localStorage.setItem('previous_route', event.url);
            this.db.loaded_previous_route = true; // should no longer be able to load previous route
          } else {
            localStorage.removeItem('previous_route');
            this.db.loaded_previous_route = true; // should no longer be able to load previous route
          }
        }, 500);
      }
    });
  }

  inAdditionalPages(previous_route) {
    let page = this.db?.user?.additional_pages?.find((page) => '/' + page.page == previous_route);
    if (page == undefined) {
      return false;
    } else {
      return true;
    }
  }

  open(page) {
    this.router.navigateByUrl(page);
  }

  onFinished(product) {
    this.countdownconfig.leftTime = 0;
  }

  getDays() {
    return Math.floor(this.countdownconfig.leftTime / 86400);
  }

  async ngOnInit() {
    let mythis = this;
    //show promo and link to extend license
    if (this.db.getPlan() == 'free') {
      let data = {
        product: this.db.appinfo.product,
      };
      await this.http.post('https://sarutech.com/api/app/getPricing', data).subscribe(
        (res) => {
          let products: any = res;
          products.map((product) => {
            if (product.name == 'Standard License' && new Date(product.discount_end) > new Date()) {
              mythis.countdownconfig = {
                leftTime: Math.max((new Date(product.discount_end).getTime() - new Date().getTime()) / 1000, 0),
                template: '$!h!h:$!m!m:$!s-ext!',
                name: product.discount_name,
                discount: product.discount,
              };
            }
          });
        },
        async (err) => {}
      );
    }
  }

  signin($event) {
    this.attendance = {
      id: this.db.user.id + '_' + new Date().toLocaleDateString().replace(/\//g, ''),
      rev: '',
      group: this.db.user.id,
      name: this.db.user.fullname,
      start: moment().format('YYYY-MM-DDTHH:mm'),
      end: null,
    };
    this.db.update(this.attendance, 'attendance');
  }

  signout($event) {
    delete this.attendance.yesterday;
    this.attendance.end = moment().format('YYYY-MM-DDTHH:mm');
    this.db.update(this.attendance, 'attendance');
  }

  changeLanguage($event) {
    this.db.language = $event.target.value;
    // save in local storage
    localStorage.setItem('language', this.db.language);
  }

  async sync() {
    this.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.loading.present();
    this.db.login();
    await this.loading.dismiss();
    this.presentToast('Reconnected Successfully', 'toast-success');
  }

  appsyncfix() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    let data = {
      id: 'appsyncfix',
    };
    this.http.post('https://sarutech.com/api/app/appsyncfix', data, { headers: headers }).subscribe(
      async (res: any) => {
        if (res.data.database == `${this.db.appinfo.product}$${this.db.gsetting.username}`) {
          await this.http
            .post('https://sarutech.com/api/app/get', { id: `setting_2_${this.db.gsetting.username}`, database: `${this.db.appinfo.product}$${this.db.gsetting.username}` })
            .toPromise()
            .then((res: any) => {
              if (res.data) {
                this.db.gsetting = res.data;
              }
              this.db.login();
              this.presentToast('Reconnected Successfully', 'toast-success');
            });
        } else {
          this.presentToast('Database is Unauthorized', 'toast-danger');
        }
      },
      (err) => {
        console.log('error');
      }
    );
  }

  extend(): void {
    this.router.navigateByUrl('/AddPaymentPage');
  }

  settings() {
    this.router.navigateByUrl('/SettingsPage');
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }
}
